import * as ng from 'angular';
import {PreviewService} from '../../../../services/preview.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {TableHeaderItem} from '../../../../commons/components/table-component/domain/table-header-item';
import {StoreService} from '../../../../services/store.service';
import {AlertService} from '../../../../services/ui/alert.service';
import {FileService} from '../../../../services/file.service';
import {rabbitMQ} from '../../../../third/rabbitMQ';

export const ConservazioneConsultaDocumentiComponent = {
  template: require('./conservazione-consulta-documenti.html'),
  controller: class ConservazioneConsultaDocumentiComponent {

    static $inject: string[] = [
      '$scope',
      '$rootScope',
      '$state',
      '$stateParams',
      'store',
      'ArchiSmallServices',
      'FileService',
      'StoreService',
      'AlertService',
      '$uibModal',
      '$sce',
      'PreviewService'
    ];

    private headerColumns: Record<string, Array<TableHeaderItem>>;

    constructor(
      private $scope: any,
      private $rootScope: any,
      private $state: any,
      private $stateParams: ng.ui.IStateParamsService,
      private store: ng.a0.storage.IStoreService,
      private ArchiSmallServices: ArchiSmallServices,
      private fileService: FileService,
      private storeService: StoreService,
      private alertService: AlertService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private $sce: ng.ISCEService,
      private PreviewService: PreviewService
    ) {
      $rootScope.conservazioneNotification.updateDocument = (document) => {
        if ($scope.items !== undefined) {
          let indexes = $.map($scope.items, (obj, index) => {
            if (obj._id === document._id) {
              return index;
            }
          });

          if (indexes !== undefined) {
            if (indexes.length === 1) {
              // replace item with new one present in notification
              document.selected = $scope.items[indexes[0]].isSelected;
              $scope.items[indexes[0]] = document;

              if ($scope.selectedItem !== undefined) {
                if ($scope.selectedItem._id === document._id) {
                  $scope.selectedItem = document;
                }
              }
            }
          }
        }
      };

      let trusted = {};

      $scope.trustAsHtml = (value) => {
        return $sce.trustAsHtml(value);
      };
      /* tslint:disable:no-string-literal */
      $scope.statoDescription = (status) => {
        switch (status) {
          case 'Da conservare':
            return trusted['da-conservare'] || (trusted['da-conservare'] = $sce.trustAsHtml('<span><b>Da Conservare</b></span><br/><span>Il documento è stato caricato e verrà conservato automaticamente il primo giorno del mese successivo al caricamento.</span>'));
          case 'Inv. in conservazione':
            return trusted['inviato-conservazione'] || (trusted['inviato-conservazione'] = $sce.trustAsHtml('<span><b>Inviato in conservazione</b></span><br/><span>Il documento è stato inviato al sistema di conservazione.</span>'));
          case 'Conservato':
            return trusted['conservato'] || (trusted['conservato'] = $sce.trustAsHtml('<span><b>Conservato</b></span><br/><span>Consulta, cerca e scarica copia dell\'originale dei documenti conservati per l\'esibizione in caso di controllo.</span>'));
          case 'Da Verificare':
            return trusted['da-verificare'] || (trusted['da-verificare'] = $sce.trustAsHtml('<span><b>Da Verificare</b></span><br/><span>Clicca qui per completare il caricamento dei dati necessari per conservare il documento.</span>'));
          case 'Errore Firma':
            return trusted['errore-firma'] || (trusted['errore-firma'] = $sce.trustAsHtml('<span><b>Errore Firma</b></span><br/><span>I documenti con <span class="red"><strong>Errore Firma</strong></span> verranno conservati solamente dopo aver configurato un certificato di firma valido e dopo aver premuto il bottone <strong>Firma tutti</strong></span>'));
          case 'Firma in corso':
            return trusted['firma-in-corso'] || (trusted['firma-in-corso'] = $sce.trustAsHtml('<span><b>Firma in corso</b></span><br/>Il documento sarà firmato usando le credenziali configurate e sarà preparato per la conservazione.'));
        }
      };
      /* tslint:enable:no-string-literal */
      $scope.user = store.get('user');
      $scope.pageHeader = 'Consulta Documenti';
      $scope.moreDataToLoad = true;
      let processingRequest = false;

      $scope.classeDocumentale = [
        {
          'key': 'pec_posta_elettronica_certificata',
          'name': 'PEC - Posta Elettronica Certificata',
          'icon': 'icon-icon_pec',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'pec_notifiche_pec',
          'name': 'PEC - Notifiche PEC',
          'icon': 'icon-icon_pec',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'mail_pec', 'name': 'Mail/PEC', 'icon': 'icon-icon_pec', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'libro_contabile',
          'name': 'Libri Contabili',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'corrispondenza_ordinaria',
          'name': 'Corrispondenza Ordinaria',
          'icon': 'icon-icon_pec',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'registro_contabile',
          'name': 'Registri Contabili',
          'icon': 'icon-icon_registri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'fatture_attive',
          'name': 'Fatture Attive',
          'icon': 'icon-icon_fatture_attive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'notifiche_sdi',
          'name': 'Notifiche SdI',
          'icon': 'icon-icon_fatture_attive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'certificazione_unica',
          'name': 'Certificazione Unica',
          'icon': 'icon-icon_fatture_attive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'documenti_bancari',
          'name': 'Documenti Bancari',
          'icon': 'icon-icon_fatture_attive',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'manuali', 'name': 'Manuali', 'icon': 'icon-icon_fatture_passive', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'modello_intrastat',
          'name': 'Modello Intrastat',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'libri_sociali',
          'name': 'Libri Sociali',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'registro_liquidazioni_iva',
          'name': 'Registro Liquidazioni Iva',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'fattura_passiva',
          'name': 'Fatture Passive',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'contratti_da_fornitore',
          'name': 'Contratti da Fornitore',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'contratti_a_cliente',
          'name': 'Contratti a Cliente',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'ordini_a_fornitore',
          'name': 'Ordini a Fornitore',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'verbali_verifica_scarto',
          'name': 'Verbali di Verifica e di Scarto',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'nomine_deleghe_conservazione',
          'name': 'Nomine e Deleghe di Conservazione',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'ordini_da_cliente',
          'name': 'Ordini da Cliente',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'registro_rifiuti',
          'name': 'Registro Carico Scarico Rifiuti',
          'icon': 'icon-icon_fatture_passive',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'fattura_elettronica_attiva',
          'name': 'Fatture Elettroniche Attive',
          'icon': 'icon-icon_file_xml',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'fattura_elettronica_attiva_notifiche',
          'name': 'Fatture Elettroniche Attive Notifiche',
          'icon': 'icon-icon_file_xml',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'fattura_elettronica_passiva',
          'name': 'Fatture Elettroniche Passive',
          'icon': 'icon-icon_file_xml',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'fattura_gse', 'name': 'Fattura GSE', 'icon': 'icon-icon_gse', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'fattura_gse_notifiche',
          'name': 'Fattura GSE Notifiche',
          'icon': 'icon-icon_gse',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'ddt_attivo', 'name': 'DDT Attivi', 'icon': 'icon-icon_ddt_attivi', 'iconSize': 'farchismall-1-2x'},
        {'key': 'ddt_passivo', 'name': 'DDT Passivi', 'icon': 'icon-icon_ddt_passivi', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'modello_dichiarativo',
          'name': 'Modelli Dichiarativi',
          'icon': 'icon-icon_dichiarativi',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'modello_versamento',
          'name': 'Modelli Versamento',
          'icon': 'icon-icon_f24',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'bollette', 'name': 'Bollette', 'icon': 'icon-icon_bollette', 'iconSize': 'farchismall-1-2x'},
        {'key': 'lul', 'name': 'LUL', 'icon': 'icon-icon_LUL', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'altro_documento',
          'name': 'Altri Documenti',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'libro_giornale', 'name': 'Libri Giornale', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {'key': 'prima_nota', 'name': 'Registro Prima Nota', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'giornali_schede_magazzino',
          'name': 'Giornali e Schede di Magazzino',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'libro_inventari',
          'name': 'Libri Inventari',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'registro_omaggi',
          'name': 'Registro Omaggi',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'libro_mastro', 'name': 'Libri Mastro', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {'key': 'libro_cespiti', 'name': 'Libri Cespiti', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {'key': 'altri_libri', 'name': 'Altri Libri', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'libro_registri_iva',
          'name': 'Registri IVA',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'registro_riepilogativo_iva',
          'name': 'Registro Riepilogativo IVA',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'altri_registri', 'name': 'Altri Registri', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'registro_fatture_acquisto',
          'name': 'Registro Fatture Acquisto',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'registro_corrispettivi_iva',
          'name': 'Registro Corrispettivi Iva',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'dichiarazioni_fiscali',
          'name': 'Dichiarazioni Fiscali',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'ricevute_fiscali',
          'name': 'Ricevute Fiscali',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'registro_beni_di_terzi',
          'name': 'Registro Beni di Terzi',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'registro_unico_iva',
          'name': 'Registro Unico Iva',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },

        {
          'key': 'registro_fatture_vendita',
          'name': 'Registro Fatture Vendita',
          'icon': 'icon-icon_libri',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'modello_f23_f24',
          'name': 'Modello F23 - F24',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'modello_770', 'name': 'Modello 770', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
        {'key': 'modello_730', 'name': 'Modello 730', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'schede_cliniche',
          'name': 'Schede Cliniche',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'cmr', 'name': 'CMR', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
        {
          'key': 'formulario_identificativo_rifiuti',
          'name': 'Formulario Identificativo Rifiuti',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'dichiarazioni_intento_attive',
          'name': 'Dichiarazioni Intento Attive',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'dichiarazioni_intento_passive',
          'name': 'Dichiarazioni Intento Passive',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'documenti_doganali_emessi',
          'name': 'Documenti Doganali Emessi',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'documenti_doganali_ricevuti',
          'name': 'Documenti Doganali Ricevuti',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'modello_unico_dichiarazione_ambientale',
          'name': 'Modello Unico Dichiarazione Ambientale',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {
          'key': 'note_spese_e_trasferte',
          'name': 'Note Spese e Trasferte',
          'icon': 'icon-icon_altro',
          'iconSize': 'farchismall-1-2x'
        },
        {'key': 'cm', 'name': 'CM', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
        {'key': 'pod', 'name': 'POD', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
        {'key': 'bilanci', 'name': 'Bilanci', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
      ].sort(({name: a}, {name: b}) => a.localeCompare(b)).filter(classe => $scope.user.classiDocumentali[classe.key]);

      $scope.iconSize = 'farchismall-1-2x';

      this.headerColumns = {
        'mail_pec': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'metadata.subject', label: 'Oggetto email @PEC', ratio: '21', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'metadata.sender', label: 'Mittente', ratio: '21', isSortable: true},
          {key: 'metadata.primary_recipient', label: 'Destinatario primario', ratio: '21', isSortable: true},
          {key: 'metadata.dataDocumento', label: 'Data', ratio: '12', isSortable: true},
          {key: 'metadata.receipt', label: 'Ricevuta', ratio: '13', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false}
        ],
        'pec_posta_elettronica_certificata': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto PEC', ratio: '21', isSortable: true},
          {key: 'mittentePec', label: 'Mittente PEC', ratio: '15', isSortable: true},
          {key: 'destinatarioPec', label: 'Destinatario PEC', ratio: '21', isSortable: true},
          {key: 'dataPec', label: 'Data PEC', ratio: '21', isSortable: true},
          {key: 'oraPec', label: 'Ora PEC', ratio: '12', isSortable: true},
          {key: 'identificativoPec', label: 'Identificativo PEC', ratio: '13', isSortable: true},
          {key: 'identificativoPecOriginale', label: 'Identificativo PEC Originale', ratio: '13', isSortable: true},
          {key: 'flussoPec', label: 'Flusso PEC', ratio: '13', isSortable: false},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'FileName', ratio: '18', isSortable: false}
        ],
        'pec_notifiche_pec': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto PEC', ratio: '21', isSortable: true},
          {key: 'mittentePec', label: 'Mittente PEC', ratio: '15', isSortable: true},
          {key: 'destinatarioPec', label: 'Destinatario PEC', ratio: '21', isSortable: true},
          {key: 'dataPec', label: 'Data PEC', ratio: '21', isSortable: true},
          {key: 'oraPec', label: 'Ora PEC', ratio: '12', isSortable: true},
          {key: 'identificativoPec', label: 'Identificativo PEC', ratio: '13', isSortable: true},
          {key: 'identificativoPecOriginale', label: 'Identificativo PEC Originale', ratio: '13', isSortable: true},
          {key: 'flussoPec', label: 'Flusso PEC', ratio: '13', isSortable: false},
          {key: 'esitoRicevutaPec', label: 'Esito Ricevuta PEC', ratio: '13', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'FileName', ratio: '18', isSortable: false}
        ],
        'corrispondenza_ordinaria': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto Email', ratio: '10', isSortable: true},
          {key: 'mittenteEmail', label: 'Mittente Email', ratio: '15', isSortable: true},
          {key: 'destinatarioEmail', label: 'Destinatario Email', ratio: '15', isSortable: true},
          {key: 'dataEmail', label: 'Data Email', ratio: '10', isSortable: true},
          {key: 'oraEmail', label: 'Ora Email', ratio: '10', isSortable: true},
          {key: 'flussoEmail', label: 'Flusso Email', ratio: '10', isSortable: false},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '10', isSortable: false},
          {key: 'fileName', label: 'FileName', ratio: '10', isSortable: false}
        ],
        'libro_contabile': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '10', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'Mese Inizio', label: 'Mese Inizio', ratio: '12', isSortable: true},
          {key: 'Mese Fine', label: 'Mese Fine', ratio: '12', isSortable: true}
        ],
        'altri_libri': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'meseInizio', label: 'Mese Inizio', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Mese Fine', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}
        ],
        'registro_contabile': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '10', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'Mese Inizio', label: 'Mese Inizio', ratio: '12', isSortable: true},
          {key: 'Mese Fine', label: 'Mese Fine', ratio: '12', isSortable: true}
        ],
        'fatture_attive': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '7', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '15', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '10', isSortable: true},
          {key: 'sezionaleIva', label: 'Sezionale Iva', ratio: '10', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '11', isSortable: true},
          {key: 'nome', label: 'Nome', ratio: '13', isSortable: true},
          {key: 'cognome', label: 'Cognome', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '10', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'notifiche_sdi': [
          {key: 'Status', label: 'Stato', ratio: '9', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'tipoNotifica', label: 'Tipo Notifica', ratio: '9', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'numeroFattura', label: 'Numero Fattura', ratio: '8', isSortable: true},
          {key: 'identificativoSdi', label: 'Identificativo SdI', ratio: '9', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '6', isSortable: true},
          {key: 'dataFattura', label: 'Data Fattura', ratio: '8', isSortable: true},
          {key: 'annoFattura', label: 'Anno Fattura', ratio: '8', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '10', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '9', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'nomeFileFattura', label: 'File Name Fattura', ratio: '8', isSortable: true}
        ],
        'certificazione_unica': [
          {key: 'Status', label: 'Stato', ratio: '19', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'contribuenteNome', label: 'Nome Contribuente', ratio: '16', isSortable: true},
          {key: 'contribuenteCognome', label: 'Cognome Contribuente', ratio: '16', isSortable: true},
          {key: 'contribuenteRagioneSociale', label: 'Ragione Sociale Contribuente', ratio: '16', isSortable: true},
          {key: 'contribuentePiva', label: 'Partita Iva', ratio: '14', isSortable: true},
          {key: 'contribuenteCodiceFiscale', label: 'Codice Fiscale', ratio: '18', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'manuali': [
          {key: 'Status', label: 'Stato', ratio: '17', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '15', isSortable: true},
          {key: 'annoDocumento', label: 'Anno Documento', ratio: '13', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '16', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'tipologiaManuale', label: 'Tipologia Manuale', ratio: '20', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'modello_intrastat': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'dataEmissioneDocumento', label: 'Data Emissione Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'numeroRiferimentoDocumento', label: 'Num. Rif. Doc.', ratio: '8', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fiscale Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fiscale Al', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Inizio mese riferimento', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Fine mese riferimento', ratio: '8', isSortable: true},
          {key: 'dataProtocollo', label: 'Data Prot.', ratio: '8', isSortable: true},
          {key: 'numeroProtocollo', label: 'Num. Prot.', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoDenominazione', label: 'Sogg. Del. Denom.', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoPiva', label: 'Sogg. Del. Piva', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoCodiceFiscale', label: 'Sogg. Del. CF', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],
        'libri_sociali': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'dataEmissioneDocumento', label: 'Data Emissione Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'numeroRiferimentoDocumento', label: 'Num. Rif. Doc.', ratio: '8', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fiscale Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fiscale Al', ratio: '8', isSortable: true},
          {key: 'dataProtocollo', label: 'Data Prot.', ratio: '8', isSortable: true},
          {key: 'numeroProtocollo', label: 'Num. Prot.', ratio: '8', isSortable: true},
          {key: 'destinatarioDenominazione', label: 'Destinat. Denom.', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Destinat. Piva', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Destinat. CF', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],
        'registro_liquidazioni_iva': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fiscale Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fiscale Al', ratio: '8', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Mese Inizio', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Mese Fine', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],
        'fattura_passiva': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '7', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '10', isSortable: true},
          {key: 'numeroProtocollo', label: 'Numero Protocollo', ratio: '10', isSortable: true},
          {key: 'dataProtocollo', label: 'Data Protocollo', ratio: '10', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '11', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'fattura_elettronica_attiva': [
          {key: 'Status', label: 'Stato', ratio: '10', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'progressivoInvio', label: 'Progressivo Invio', ratio: '6', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '11', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '11', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '10', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '19', isSortable: true}
        ],
        'fattura_elettronica_attiva_notifiche': [
          {key: 'Status', label: 'Stato', ratio: '10', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'progressivoInvio', label: 'Progressivo Invio', ratio: '6', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '11', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '11', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '10', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'fattura_elettronica_passiva': [
          {key: 'Status', label: 'Stato', ratio: '10', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'progressivoInvio', label: 'Progressivo Invio', ratio: '6', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '11', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '11', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '10', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '19', isSortable: true}
        ],
        'fattura_gse': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'progressivoInvio', label: 'Progressivo Invio', ratio: '11', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '11', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '11', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '11', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'fattura_gse_notifiche': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'progressivoInvio', label: 'Progressivo Invio', ratio: '11', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '11', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '11', isSortable: true},
          {key: 'denominazione', label: 'Denominazione', ratio: '13', isSortable: true},
          {key: 'partitaIva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '11', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '18', isSortable: true}
        ],
        'ddt_attivo': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '10', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '13', isSortable: true},
          {key: 'cliente.nome', label: 'Nome', ratio: '13', isSortable: true},
          {key: 'cliente.cognome', label: 'Cognome', ratio: '13', isSortable: true},
          {key: 'cliente.denominazione', label: 'Denominazione', ratio: '15', isSortable: true},
          {key: 'cliente.piva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'cliente.codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '20', isSortable: true}
        ],
        'ddt_passivo': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '10', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '13', isSortable: true},
          {key: 'numeroProtocollo', label: 'Numero Protocollo', ratio: '10', isSortable: true},
          {key: 'dataProtocollo', label: 'Data Protocollo', ratio: '10', isSortable: true},
          {key: 'fornitore.denominazione', label: 'Denominazione', ratio: '15', isSortable: true},
          {key: 'fornitore.piva', label: 'Partita Iva', ratio: '13', isSortable: true},
          {key: 'fornitore.codiceFiscale', label: 'Codice Fiscale', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '20', isSortable: true}
        ],
        'modello_dichiarativo': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '15', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '40', isSortable: true}
        ],
        'modello_versamento': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '15', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '15', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '40', isSortable: true}
        ],
        'bollette': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '13', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '15', isSortable: true},
          {key: 'Mese Inizio', label: 'Mese Inizio', ratio: '12', isSortable: true},
          {key: 'Mese Fine', label: 'Mese Fine', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '20', isSortable: true}
        ],
        'lul': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome', ratio: '20', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome', ratio: '20', isSortable: true},
          {key: 'Oggetto', label: 'Oggetto', ratio: '20', isSortable: false},
          {key: 'anno', label: 'Anno', ratio: '10', isSortable: true},
          {key: 'mese', label: 'Mese', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '15', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '40', isSortable: true}
        ],
        'altro_documento': [
          {key: 'Status', label: 'Stato', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '10', isSortable: true},
          {key: 'Tipo Documento', label: 'Tipo Documento', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '19', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'libro_giornale': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'prima_nota': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '17', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'giornali_schede_magazzino': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'libro_inventari': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'registro_omaggi': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}
        ],
        'libro_mastro': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],
        'libro_cespiti': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],
        'libro_registri_iva': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '16', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '25', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '12', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],

        'verbali_verifica_scarto': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Rif. Doc.', ratio: '8', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],


        'nomine_deleghe_conservazione': [
          {key: 'Status', label: 'Stato', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'oggetto', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],


        'registro_riepilogativo_iva': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '17', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '26', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '12', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],
        'altri_registri': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '17', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '26', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '12', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],
        'registro_fatture_acquisto': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '17', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '26', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '12', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],

        'registro_fatture_vendita': [
          {key: 'Status', label: 'Stato', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '12', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'Periodo di Esercizio', label: 'Periodo', ratio: '9', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '17', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '26', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '12', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '12', isSortable: true}],

        'registro_corrispettivi_iva': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Mese Inizio', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Mese Fine', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'destinatarioDenominazione', label: 'Destinatario Denominazione', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Destinatario Piva', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Destinatario Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],

        'dichiarazioni_fiscali': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Inizio mese di riferimento', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Fine mese di riferimento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'protocolloTelematico', label: 'Protocollo Telematico', ratio: '8', isSortable: true},          
          {key: 'destinatarioDenominazione', label: 'Destinatario Denominazione', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Destinatario Piva', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Destinatario Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoDenominazione', label: 'Soggetto Delegato Denominazione', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoPiva', label: 'Soggetto Delegato Piva', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoCodiceFiscale', label: 'Soggetto Delegato Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],

        'ricevute_fiscali': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Inizio mese di riferimento', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Fine mese di riferimento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'protocolloTelematico', label: 'Protocollo Telematico', ratio: '8', isSortable: true},          
          {key: 'mittenteDenominazione', label: 'Mittente Denominazione', ratio: '8', isSortable: true},
          {key: 'mittentePiva', label: 'Mittente Piva', ratio: '8', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Mittente Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoDenominazione', label: 'Soggetto Delegato Denominazione', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoPiva', label: 'Soggetto Delegato Piva', ratio: '8', isSortable: true},
          {key: 'soggettoDelegatoCodiceFiscale', label: 'Soggetto Delegato Codice Fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],

        'registro_beni_di_terzi': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],

        'registro_unico_iva': [
          {key: 'Status', label: 'Stato', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno IVA', ratio: '8', isSortable: true},
          {key: 'meseInizio', label: 'Mese Inizio', ratio: '8', isSortable: true},
          {key: 'meseFine', label: 'Mese Fine', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true}],


        'modello_f23_f24': [
          {key: 'Status', label: 'Stato', ratio: '6', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '6', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '6', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome destinatario', ratio: '6', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome destinatario', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Ragione sociale destinatario', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva destinatario', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale destinatario', ratio: '6', isSortable: true},
          {key: 'contribuenteNome', label: 'Nome contribuente', ratio: '6', isSortable: true},
          {key: 'contribuenteCognome', label: 'Cognome contribuente', ratio: '6', isSortable: true},
          {key: 'contribuenteRagioneSociale', label: 'Ragione sociale contribuente', ratio: '6', isSortable: true},
          {key: 'contribuentePiva', label: 'Piva contribuente', ratio: '6', isSortable: true},
          {key: 'contribuenteCodiceFiscale', label: 'Codice fiscale contribuente', ratio: '6', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],
        'modello_770': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '12', isSortable: false},
          {key: 'Data', label: 'Data Caricamento Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '5', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '6', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag. soc. dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale dest.', ratio: '12', isSortable: true},
          {key: 'sostitutoimpostaNome', label: 'Nome Sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaCognome', label: 'Cognome sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaRagioneSociale', label: 'Rag. soc. sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaPiva', label: 'Piva sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaCodiceFiscale', label: 'Codice fiscale sost. imp.', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],
        'schede_cliniche': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '13', isSortable: true},
          {key: 'numeroUnivocoPaziente', label: 'N. Univoco Paziente', ratio: '11', isSortable: false},
          {key: 'codiceCartellaClinica', label: 'Cod. Cartella Clinica', ratio: '12', isSortable: false},
          {key: 'dataCreazione', label: 'Data Creaz.', ratio: '8', isSortable: true},
          {key: 'dataRegistrazione', label: 'Data Reg.', ratio: '8', isSortable: true},
          {key: 'annoCreazione', label: 'Anno Creaz.', ratio: '9', isSortable: true},
          {key: 'annoDocumento', label: 'Anno Doc.', ratio: '8', isSortable: true},
          {key: 'annoRegistrazionel', label: 'Anno Reg.', ratio: '8', isSortable: true},
          {key: 'mittenteNome', label: 'Nome Mittente', ratio: '6', isSortable: true},
          {key: 'mittenteaCognome', label: 'Cognome Mittente', ratio: '6', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag. soc. Mittente.', ratio: '6', isSortable: true},
          {key: 'mittentePiva', label: 'Piva Mittente', ratio: '8', isSortable: true},
          {key: 'mittenteaCodiceFiscale', label: 'Codice fiscale Mittente', ratio: '8', isSortable: true},
          {key: 'mittenteIpa', label: 'Ipa Mittente', ratio: '6', isSortable: true},
          {key: 'mittenteCodiceUfficio', label: 'Mittente Codice Ufficio', ratio: '6', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag. soc. dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioIpa', label: 'Ipa Mittente', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceUfficio', label: 'Mittente Codice Ufficio', ratio: '6', isSortable: true},
          {key: 'identificativoDocumento', label: 'Id. Documento', ratio: '12', isSortable: false},
          // { key: 'identificativoUnivocoConservazione', label: 'Id. Univoco Conservazione', ratio: '8', isSortable: true },
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'registro_rifiuti': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '8', isSortable: false},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva.', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'meseRiferimento', label: 'Mese di Rif.', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'contratti_da_fornitore': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva.', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '13', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Doc.', ratio: '9', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '6', isSortable: true},
          {key: 'mittenteaNome', label: 'Nome Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteaCognome', label: 'Cognome Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag. soc. Fornitore.', ratio: '6', isSortable: true},
          {key: 'mittentePiva', label: 'Piva Fornitore', ratio: '8', isSortable: true},
          {key: 'mittenteaCodiceFiscale', label: 'Codice fiscale Fornitore', ratio: '8', isSortable: true},
          {key: 'mittenteIpa', label: 'Ipa Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteCodiceUfficio', label: 'Codice Ufficio Fornitore', ratio: '6', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'contratti_a_cliente': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva.', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '13', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Doc.', ratio: '9', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '6', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome Cliente', ratio: '6', isSortable: true},
          {key: 'destinatatioCognome', label: 'Cognome Cliente', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag. soc. Cliente.', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Cliente', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale Cliente', ratio: '8', isSortable: true},
          {key: 'destinatarioIpa', label: 'Ipa Cliente', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceUfficio', label: 'Codice Ufficio Cliente', ratio: '6', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'ordini_da_cliente': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'numeroDocumento', label: 'Num. Ord.Vend.', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Ord.Vend.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva.', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '13', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome Cliente', ratio: '6', isSortable: true},
          {key: 'destinatatioCognome', label: 'Cognome Cliente', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag. soc. Cliente.', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Cliente', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale Cliente', ratio: '8', isSortable: true},
          {key: 'destinatarioIpa', label: 'Ipa Cliente', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceUfficio', label: 'Codice Ufficio Cliente', ratio: '6', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'ordini_a_fornitore': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'numeroDocumento', label: 'Num. Ord.Acq.', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Ord.Acq.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva.', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '13', isSortable: true},
          {key: 'mittenteNome', label: 'Nome Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteCognome', label: 'Cognome Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag. soc. Fornitore.', ratio: '6', isSortable: true},
          {key: 'mittentePiva', label: 'Piva Fornitore', ratio: '8', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Codice fiscale Fornitore', ratio: '8', isSortable: true},
          {key: 'mittenteIpa', label: 'Ipa Fornitore', ratio: '6', isSortable: true},
          {key: 'mittenteCodiceUfficio', label: 'Codice Ufficio Fornitore', ratio: '6', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'modello_730': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '12', isSortable: false},
          {key: 'dataDocumento', label: 'Data Caricamento Doc.', ratio: '8', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '5', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '5', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '6', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag. soc. dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva dest.', ratio: '6', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale dest.', ratio: '12', isSortable: true},
          {key: 'sostitutoimpostaNome', label: 'Nome Sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaCognome', label: 'Cognome sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaRagioneSociale', label: 'Rag. soc. sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaPiva', label: 'Piva sost. imp.', ratio: '6', isSortable: true},
          {key: 'sostitutoimpostaCodiceFiscale', label: 'Codice fiscale sost. imp.', ratio: '12', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '6', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '6', isSortable: true}
        ],

        'cm': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '10', isSortable: true},
          {key: 'vetttoreNome', label: 'Nome Vett.', ratio: '10', isSortable: true},
          {key: 'vettoreCognome', label: 'Cogn. Vett', ratio: '10', isSortable: true},
          {key: 'vettoreRagioneSociale', label: 'Rag.Soc. Vett.', ratio: '10', isSortable: true},
          {key: 'vettorePiva', label: 'Piva vett', ratio: '10', isSortable: true},
          {key: 'vettoreCodiceFiscale', label: 'Cod.Fisc. Vett.', ratio: '15', isSortable: true},
          {key: 'vettoreIpa', label: 'Cod. Ipa Vett.', ratio: '15', isSortable: true},
          {key: 'vettoreCodiceCodiceUfficio', label: 'Cod. Uff. Vett.', ratio: '15', isSortable: true},
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '10', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '12', isSortable: true}
        ],
        'cmr': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'annoDocumento', label: 'Anno Doc.', ratio: '5', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '5', isSortable: true},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '10', isSortable: true},
          {key: 'mittenteNome', label: 'Nome Mitt.', ratio: '10', isSortable: true},
          {key: 'mittenteCognome', label: 'Cogn. Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag.Soc. Mitt', ratio: '10', isSortable: true},
          {key: 'mittemtePiva', label: 'Piva Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '15', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cogn. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag.Soc. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '15', isSortable: true},
          {key: 'vetttoreNome', label: 'Nome Vett.', ratio: '10', isSortable: true},
          {key: 'vettoreCognome', label: 'Cogn. Vett', ratio: '10', isSortable: true},
          {key: 'vettoreRagioneSociale', label: 'Rag.Soc. Vett.', ratio: '10', isSortable: true},
          {key: 'vettorePiva', label: 'Piva vett', ratio: '10', isSortable: true},
          {key: 'vettoreCodiceFiscale', label: 'Cod.Fisc. Vett.', ratio: '15', isSortable: true},
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '10', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '12', isSortable: true}
        ],
        'formulario_identificativo_rifiuti': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '15', isSortable: true},
          {key: 'Data', label: 'Data Caric.', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '9', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '9', isSortable: true},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'idCodiceRegistro', label: 'Id Cod.Reg.', ratio: '12', isSortable: true},
          {key: 'numeroRegistro', label: 'Num. Reg.', ratio: '16', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'meseRiferimento', label: 'Mese Rif.', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '5', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '5', isSortable: true},
          {key: 'tipologiaRifiuto', label: 'Tipo Rifiuto', ratio: '8', isSortable: true},
          {key: 'numeroFormulario', label: 'Num. Form.', ratio: '8', isSortable: true},
          //
          //{key: 'mittenteDenominazione', label: 'Denom. Mitt', ratio: '8', isSortable: true},
          //{key: 'mittentePiva', label: 'Piva Mitt', ratio: '8', isSortable: true},
          //{key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '8', isSortable: true},
          //
          {key: 'destinatarioDenominazione', label: 'Denom. Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '8', isSortable: true},
          //
          {key: 'trasportatoreDenominazione', label: 'Denom. Trasp.', ratio: '8', isSortable: true},
          {key: 'trasportatorePiva', label: 'Piva Trasp', ratio: '8', isSortable: true},
          {key: 'trasportatoreCodiceFiscale', label: 'Cod.Fisc. Trasp.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'dichiarazioni_intento_attive': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          {key: 'annoDocumento', label: 'Anno Docum.', ratio: '8', isSortable: true},
          //
          //{key: 'mittenteDenominazione', label: 'Denom. Mitt', ratio: '8', isSortable: true},
          //{key: 'mittentePiva', label: 'Piva Mitt', ratio: '8', isSortable: true},
          //{key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '8', isSortable: true},
          //
          {key: 'destinatarioDenominazione', label: 'Denom. Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'dichiarazioni_intento_passive': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          {key: 'annoDocumento', label: 'Anno Docum.', ratio: '8', isSortable: true},
          //
          {key: 'mittenteDenominazione', label: 'Denom. Mitt', ratio: '8', isSortable: true},
          {key: 'mittentePiva', label: 'Piva Mitt', ratio: '8', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'documenti_doganali_emessi': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          {key: 'meseRiferimento', label: 'Mese', ratio: '8', isSortable: true},
          {key: 'doganaRilascio', label: 'Dogana Rilascio', ratio: '8', isSortable: true},
          {key: 'numeroMRN', label: 'Numero MRN', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo DOc.', ratio: '8', isSortable: true},
          {key: 'numeroFatturaCliente', label: 'Num. Fatt. Cli.', ratio: '8', isSortable: true},
          //
          //{key: 'mittenteDenominazione', label: 'Denom. Mitt', ratio: '8', isSortable: true},
          //{key: 'mittentePiva', label: 'Piva Mitt', ratio: '8', isSortable: true},
          //{key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '8', isSortable: true},
          //
          {key: 'destinatarioDenominazione', label: 'Denom. Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],
        'documenti_doganali_ricevuti': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Documento', ratio: '8', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          {key: 'meseRiferimento', label: 'Mese', ratio: '8', isSortable: true},
          {key: 'doganaRilascio', label: 'Dogana Rilascio', ratio: '8', isSortable: true},
          {key: 'numeroMRN', label: 'Numero MRN', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo DOc.', ratio: '8', isSortable: true},
          {key: 'numeroFatturaCliente', label: 'Num. Fatt. Cli.', ratio: '8', isSortable: true},
          //
          {key: 'mittenteDenominazione', label: 'Denom. Mitt', ratio: '8', isSortable: true},
          {key: 'mittentePiva', label: 'Piva Mitt', ratio: '8', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '8', isSortable: true},
          //
          //{key: 'destinatarioDenominazione', label: 'Denom. Dest.', ratio: '8', isSortable: true},
          //{key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '8', isSortable: true},
          //{key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'modello_unico_dichiarazione_ambientale': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '8', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '9', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          //
          {key: 'trasportatoreDenominazione', label: 'Denom. Trasp.', ratio: '8', isSortable: true},
          {key: 'trasportatorePiva', label: 'Piva Trasp', ratio: '8', isSortable: true},
          {key: 'trasportatoreCodiceFiscale', label: 'Cod.Fisc. Trasp.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'note_spese_e_trasferte': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '12', isSortable: true},
          {key: 'Data', label: 'Data Caricamento', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '8', isSortable: false},
          //
          {key: 'annoIva', label: 'Anno Iva', ratio: '8', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '9', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'annoDocumento', label: 'Anno Documento', ratio: '8', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Anno Fisc. Dal', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Anno Fisc. Al', ratio: '8', isSortable: true},
          //
          {key: 'dataCompetenzaDal', label: 'Data Competenza Dal', ratio: '8', isSortable: true},
          {key: 'dataCompetenzaAl', label: 'Data Competenza Al', ratio: '8', isSortable: true},
          //
          {key: 'dipendenteDenominazione', label: 'Denom. Dipend.', ratio: '8', isSortable: true},
          {key: 'dipendenteCodice', label: 'Codice Dipend.', ratio: '8', isSortable: true},
          {key: 'dipendenteCodiceFiscale', label: 'Cod.Fisc. Dipend.', ratio: '8', isSortable: true},
          //
          {key: 'destinatarioDenominazione', label: 'Denom. Dest.', ratio: '8', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest', ratio: '8', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '8', isSortable: true},
          //
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ],

        'pod': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '13', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'annoDocumento', label: 'Anno Doc.', ratio: '5', isSortable: true},
          {key: 'annoIva', label: 'Anno Iva', ratio: '5', isSortable: true},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '10', isSortable: true},
          {key: 'mittenteNome', label: 'Nome Mitt.', ratio: '10', isSortable: true},
          {key: 'mittenteCognome', label: 'Cogn. Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag.Soc. Mitt', ratio: '10', isSortable: true},
          {key: 'mittemtePiva', label: 'Piva Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '15', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cogn. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag.Soc. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '15', isSortable: true},
          {key: 'vettoreNome', label: 'Nome Vett.', ratio: '10', isSortable: true},
          {key: 'vettoreCognome', label: 'Cogn. Vett', ratio: '10', isSortable: true},
          {key: 'vettoreRagioneSociale', label: 'Rag.Soc. Vett.', ratio: '10', isSortable: true},
          {key: 'vettorePiva', label: 'Piva vett', ratio: '10', isSortable: true},
          {key: 'vettoreCodiceFiscale', label: 'Cod.Fisc. Vett.', ratio: '15', isSortable: true},
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '10', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '12', isSortable: true}
        ],
        'documenti_bancari': [
          {key: 'Status', label: 'Stato Conservazione', ratio: '13', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '11', isSortable: false},
          {key: 'dataDocumento', label: 'Data Doc.', ratio: '8', isSortable: true},
          {key: 'numeroDocumento', label: 'Num. Doc.', ratio: '10', isSortable: true},
          {key: 'oggettoDescrizione', label: 'Oggetto', ratio: '10', isSortable: true},
          {key: 'tipoDocumento', label: 'Tipo Documento', ratio: '10', isSortable: true},
          {key: 'mittenteNome', label: 'Nome Mitt.', ratio: '10', isSortable: true},
          {key: 'mittenteCognome', label: 'Cogn. Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteRagioneSociale', label: 'Rag.Soc. Mitt', ratio: '10', isSortable: true},
          {key: 'mittemtePiva', label: 'Piva Mitt', ratio: '10', isSortable: true},
          {key: 'mittenteCodiceFiscale', label: 'Cod.Fisc. Mitt.', ratio: '15', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cogn. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Rag.Soc. Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva Dest.', ratio: '10', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Cod.Fisc. Dest.', ratio: '15', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responabileConservazione', label: 'Responsabile conservazione', ratio: '10', isSortable: true},
          {key: 'fileName', label: 'File Name', ratio: '12', isSortable: true}
        ],
        'bilanci': [
          {key: 'Status', label: 'Stato', ratio: '9', isSortable: true},
          {key: 'Data', label: 'Data di Caricamento', ratio: '10', isSortable: true},
          {key: 'dataDocumento', label: 'Data Documento', ratio: '9', isSortable: true},
          {key: 'numeroDocumento', label: 'Numero Documento', ratio: '15', isSortable: true},
          {key: 'oggetoDescrizione', label: 'Oggetto', ratio: '8', isSortable: true},
          {key: 'destinatarioNome', label: 'Nome destinatario', ratio: '8', isSortable: true},
          {key: 'destinatarioCognome', label: 'Cognome destinatario', ratio: '9', isSortable: true},
          {key: 'destinatarioRagioneSociale', label: 'Ragione sociale destinatario', ratio: '9', isSortable: true},
          {key: 'destinatarioPiva', label: 'Piva destinatario', ratio: '9', isSortable: true},
          {key: 'destinatarioCodiceFiscale', label: 'Codice fiscale destinatario', ratio: '8', isSortable: true},
          {key: 'annoFiscaleDal', label: 'Inizio di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'annoFiscaleAl', label: 'Fine di esercizio fiscale', ratio: '8', isSortable: true},
          {key: 'responsabileConservazione', label: 'Responsabile conservazione', ratio: '8', isSortable: true},
          {key: 'TDocPdVId', label: 'IDPDV', ratio: '15', isSortable: false},
          {key: 'fileName', label: 'File Name', ratio: '8', isSortable: true}
        ]
      };

      $scope.settings = {
        'filter': {
          'user': this.storeService.getCurrentUser().sub,
          'classeDocumentale': $stateParams.classeDocumentale,
          '_id': $stateParams.id,
          'periodo': '',
          'anno': '',
          'dataCaricamentoFrom': '',
          'dataCaricamentoTo': '',
          'dataDocumentoFrom': '',
          'dataDocumentoTo': '',
          'tipoDocumento': '',
          'fileName': '',
          'meseInizio': '',
          'meseFine': '',
          'mese': '',
          'stato': '0',
          'denominazione': '',
          'partitaIva': '',
          'codiceFiscale': '',
          'progressivoInvio': '',
          'numeroDocumento': '',
          'sender': '',
          'primaryRecipient': '',
          'subject': '',
          'receipt': '',
          'oggettoDescrizione': '',
          'annoFiscaleDal': '',
          'annoFiscaleAl': '',
          'annoIva': '',
          'responsabileConservazione': '',
          'numeroProtocollo': '',
          'dataProtocolloFrom': '',
          'dataProtocolloTo': '',
          'annoFattura': '',
          'sezionaleIva': '',
          'codiceIpa': '',
          'fornitoreCodiceUfficio': '',

          'numeroUnivocoPaziente': '',
          'identificativoDocumento': '',
          'identificativoUnivocoConservazione': '',
          'codiceCartellaClinica': '',
          'dataRiferimento': '',
          'dataCreazione': '',
          'annoCreazione': '',
          'annoDocumento': '',
          'annoRegistrazione': '',
          dataRegistrazione: '',

          mittentePec: '',
          destinatarioPec: '',
          dataPecDa: '',
          dataPecA: '',
          oraPec: '',
          identificativoPec: '',
          identificativoPecOriginale: '',
          flussoPec: '',
          esitoRicevutaPec: '',

          mittenteEmail: '',
          destinatarioEmail: '',       
          dataEmailDa: '',
          dataEmailA: '',   
          flussoEmail: '',                    

          'pageNumber': 1,
          'pageSize': 100
        },
        'sortField': '_id',
        'sortDirection': -1,
        'pageSizes': [20, 50, 100]
      };

      $scope.documentStatuses = [
        {name: '', class: ''},
        {name: 'Da conservare', class: 'label-warning'},
        {name: 'Conservato', class: 'label-success'},
        {name: 'Preso in carico', class: 'label-warning'},
        {name: 'Negativo', class: 'label-danger'},
        {name: 'Da Verificare', class: 'label-info'},
        {name: 'In Queue', class: 'label-warning'},
        {name: 'Worker Error', class: 'label-danger'},
        {name: 'Errore Firma', class: 'label-danger'},
        {name: 'Firma in corso', class: 'label-warning'},
        {name: 'Inv. in conservazione', class: 'label-warning'}
      ];

      $scope.selectedItems = [];

      $scope.openConsultaDocumentiFilterModal = (size) => {
        let ConsultaDocumentiFilterModalInstance = $uibModal.open({
          animation: true,
          component: 'consultaDocumentiFilterComponent',
          size: size,
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            filter: () => {
              return $scope.settings;
            },
            selected: () => {
              return $scope.selectedItems;
            }
          }
        });
        ConsultaDocumentiFilterModalInstance.result.then((settings) => {
          if (settings !== undefined) {
            $scope.settings = settings;
            $scope.selectedItems = [];
            $scope.settings.filter.pageNumber = 1;
            $scope.getItems();
          }
        });
      };

      $scope.getItems = (classeDocumentaleObject) => {
        if ($scope.settings.filter.classeDocumentale === '' || processingRequest) {
          return;
        }

        if (classeDocumentaleObject !== undefined && typeof classeDocumentaleObject === 'object') {
          $scope.settings.filter.classeDocumentale = classeDocumentaleObject.key;
        }

        processingRequest = true;
        $scope.isLoading = true;
        ArchiSmallServices.getConservazioneDocuments($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection)
          .then((response: any) => {
            if (response.Result === 1) {
              $scope.settings.itemsCount = response.itemsCount;
              $scope.items = response.resultList;


              $scope.moreDataToLoad = $scope.items.length < $scope.settings.itemsCount;
            }

            $scope.selectedItem = {};
            $scope.selectedItems = [];
            $scope.selectedDocuments = [];
            processingRequest = false;
          }).catch((error) => {
          this.alertService.alert('error', error);
          processingRequest = false;
        }).finally(() => {
          $scope.isLoading = false;
        });
      };

      $scope.clearFilter = () => {
        $scope.clearSettingsFilter();
        $scope.getItems();
      };

      $scope.clearSettingsFilter = () => {
        $scope.settings.filter._id = '';
        $scope.settings.filter.dataCaricamentoFrom = '';
        $scope.settings.filter.dataCaricamentoTo = '';
        $scope.settings.filter.dataDocumentoFrom = '';
        $scope.settings.filter.dataDocumentoTo = '';
        $scope.settings.filter.tipoDocumento = '';
        $scope.settings.filter.fileName = '';
        $scope.settings.filter.meseInizio = '';
        $scope.settings.filter.meseFine = '';
        $scope.settings.filter.stato = '0';
        $scope.settings.filter.periodo = '';
        $scope.settings.filter.denominazione = '';
        $scope.settings.filter.partitaIva = '';
        $scope.settings.filter.codiceFiscale = '';
        $scope.settings.filter.progressivoInvio = '';
        $scope.settings.filter.numeroDocumento = '';
        $scope.settings.filter.sender = '';
        $scope.settings.filter.primaryRecipient = '';
        $scope.settings.filter.subject = '';
        $scope.settings.filter.receipt = '';
        $scope.settings.filter.anno = '';
        $scope.settings.filter.mese = '';
        $scope.settings.filter.oggettoDescrizione = '';
        $scope.settings.filter.annoFiscaleDal = '';
        $scope.settings.filter.annoFiscaleAl = '';
        $scope.settings.filter.annoIva = '';
        $scope.settings.filter.responsabileConservazione = '';
        $scope.settings.filter.numeroProtocollo = '';
        $scope.settings.filter.dataProtocolloFrom = '';
        $scope.settings.filter.dataProtocolloTo = '';
        $scope.settings.filter.annoFattura = '';
        $scope.settings.filter.sezionaleIva = '';
        $scope.settings.filter.codiceIpa = '';
        $scope.settings.filter.codiceUfficio = '';
        $scope.settings.filter.numeroFattura = '';
        $scope.settings.filter.identificativoSdi = '';
        $scope.settings.filter.tipoNotifica = '';
        $scope.settings.filter.dataFatturaFrom = '';
        $scope.settings.filter.dataFatturaTo = '';
        $scope.settings.filter.nomeFileFattura = '';
        $scope.settings.filter.annoDocumento = '';
        $scope.settings.filter.tipologiaManuale = '';

        $scope.settings.filter.destinatarioNome = '';
        $scope.settings.filter.destinatarioCognome = '';
        $scope.settings.filter.destinatarioRagioneSociale = '';
        $scope.settings.filter.destinatarioPiva = '';
        $scope.settings.filter.destinatarioCodiceFiscale = '';

        $scope.settings.filter.contribuenteNome = '';
        $scope.settings.filter.contribuenteCognome = '';
        $scope.settings.filter.contribuenteRagioneSociale = '';
        $scope.settings.filter.contribuentePiva = '';
        $scope.settings.filter.contribuenteCodiceFiscale = '';

        $scope.settings.filter.sostitutoimpostaNome = '';
        $scope.settings.filter.sostitutoimpostaCognome = '';
        $scope.settings.filter.sostitutoimpostaRagioneSociale = '';
        $scope.settings.filter.sostitutoimpostaPiva = '';
        $scope.settings.filter.sostitutoimpostaCodiceFiscale = '';

        $scope.settings.filter.numeroOrdine = '';
        $scope.settings.filter.annoOrdineAcquisto = '';
        $scope.settings.filter.dataOrdineFrom = '';
        $scope.settings.filter.dataOrdineTo = '';

        $scope.settings.filter.numeroUnivocoPaziente = '';
        $scope.settings.filter.identificativoDocumento = '';
        $scope.settings.filter.identificativoUnivocoConservazione = '';
        $scope.settings.filter.codiceCartellaClinica = '';
        $scope.settings.filter.dataRiferimento = '';
        $scope.settings.filter.dataCreazione = '';
        $scope.settings.filter.dataRegistrazione = '';
        $scope.settings.filter.annoCreazione = '';
        $scope.settings.filter.annoDocumento = '';
        $scope.settings.filter.annoRegistrazione = '';

        $scope.settings.filter.mittentePec = '';
        $scope.settings.filter.destinatarioPec = '';
        $scope.settings.filter.dataPecDa = '';
        $scope.settings.filter.dataPecA = '';
        $scope.settings.filter.oraPec = '';
        $scope.settings.filter.identificativoPec = '';
        $scope.settings.filter.identificativoPecOriginale = '';
        $scope.settings.filter.flussoPec = '';
        $scope.settings.filter.esitoRicevutaPec = '';
        $scope.settings.filter.meseRiferimento = '';
        $scope.settings.filter.idCodiceRegistro = '';
        $scope.settings.filter.numeroRegistro = '';
        $scope.settings.filter.tipologiaRifiuto = '';

        $scope.settings.filter.mittenteEmail = '';
        $scope.settings.filter.destinatarioEmail = '';
        $scope.settings.filter.dataEmailDa = '';
        $scope.settings.filter.dataEmailA = '';
        $scope.settings.filter.flussoEmail = '';        

        $scope.selectedItems = [];
        $scope.selectedDocuments = [];
        $scope.settings.filter.pageNumber = 1;
        $scope.items = [];
        $scope.moreDataToLoad = true;
      };

      $scope.classeDocumentaleChanged = (classeDocumentaleObject) => {
        $scope.selectedItems = [];
        $scope.selectedDocuments = [];
        $scope.clearSettingsFilter();
        $scope.settings.filter.classeDocumentale = classeDocumentaleObject.key;
        $scope.getItems(classeDocumentaleObject);
      };

      $scope.getItemById = (id) => {
        for (let item in $scope.items) {
          if ($scope.items[item]._id === id) {
            $scope.selectedItem = $scope.items[item];
          }
        }
      };

      $scope.clearSelection = () => {
        $scope.selectedItems = [];
        $scope.selectedDocuments = [];
        for (let i = 0; i < $scope.items.length; i++) {
          $scope.items[i].isSelected = false;
        }
      };

      $scope.exportCsv = () => {
        $scope.settings.filter.stato = '2';
        let CreateModal = $uibModal.open({
          animation: true,
          component: 'workerDownloadCsvClientiModalComponent',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            settings: {
              user: $rootScope.currentUser().sub,
              key: 'exportCsvDataConserved',
              filters: $scope.settings.filter
            }
          }
        });
        CreateModal.result.catch(error => {
          console.error('Error:', error);
        })
          .finally(() => {
            $state.reload();
          });
      };

      $scope.contextMenuItemTitle = '<span><strong class=\'centered\'>' + $scope.selectedItems.length + ' items selected</strong></span>';
      $scope.contextMenuOptions = (invoiceDocument, index) => {
        // menu per selezione multipla
        if ($scope.selectedItems.length > 1) {
          $scope.menuOptionsMultiple[0][0] = '<span><strong>Documenti multipli (' + $scope.selectedItems.length + ')</strong></span>';
          return $scope.menuOptionsMultiple;
        } else {
          if (invoiceDocument.numeroDocumento !== undefined) {
            $scope.menuOptionsSingle[0][0] = '<span><strong>Documento ' + invoiceDocument.numeroDocumento + '</strong></span>';
          } else {
            $scope.menuOptionsSingle[0][0] = '<span><strong>Documento ' + ++index + '</strong></span>';
          }
          return $scope.menuOptionsSingle;
        }
      };

      $scope.contextMenuItemFO = '<i class=\'icon-icon_file\'></i> <span>Scarica Originale Conservato</span>';
      $scope.contextMenuItemRDV = '<i class=\'icon-icon_file\'></i> <span>Scarica Ricevuta di Versamento</span>';
      // $scope.contextMenuItemDIP = '<i class=\'icon-icon_pack_dip\'></i> <span>Scarica Pacchetto Conservato</span>';
      $scope.contextMenuPackageFO = '<i class=\'icon-icon_pack_fo\'></i> <span>Scarica Originali Conservati</span>';
      // $scope.contextMenuPackageRDV = '<i class=\'icon-icon_pack_rdv\'></i> <span>Scarica Ricevuta di Versamento</span>';
      // $scope.contextMenuPackageDIP = '<i class=\'icon-icon_pack_dip\'></i> <span>Scarica Pacchetti Conservati</span>';
      $scope.contextMenuItemPreview = '<i class=\'fa fa-eye\'></i> <span>Anteprima</span>';

      // if ($scope.user.isPro || true) {
      $scope.menuOptionsSingle = [
        [$scope.contextMenuItemTitle, ($itemScope) => {
          // console.log($itemScope);
        }],
        null,
        [$scope.contextMenuItemFO, ($itemScope) => {
          this.fileService.downloadFile($itemScope.item.FilePath);
        }],
        null,
        [$scope.contextMenuItemRDV, ($itemScope) => {
          this.fileService.downloadTDocFile($itemScope.item, 'RDV');
        }],
        null,
        [$scope.contextMenuItemPreview, ($itemScope) => {
          this.PreviewService.showPreview($itemScope.item, $scope.previewModal);
        }]
      ];

      $scope.downloadRdv = () => {
        if ($scope.selectedDocuments.length === 1) {
          this.fileService.downloadTDocFile($scope.selectedDocuments[0], 'RDV');
        } else {
          // da implementare per più file alla volta
        }
      };
      $scope.downloadOriginale = () => {
        // console.log($scope.selectedDocuments);
        if ($scope.selectedDocuments.length === 1) {
          this.fileService.downloadFile($scope.selectedDocuments[0].FilePath);
        } else {
          // da implementare per più file alla volta
        }
      };

      $scope.addOrRemoveSelectedItems = (item) => {
        // removed multi selection management
        // controllare se servono davvero poi togliere
        if (item.isSelected) {
          $scope.selectedItem = item;
          $scope.selectedItems = [];
          $scope.selectedItems.push(item._id);
        } else {
          $scope.selectedItem = {};
          $scope.selectedItems = [];
        }
        //
        $scope.selectedDocuments = $scope.selectedDocuments.filter(item => item.isSelected);
        if (item.isSelected && !$scope.selectedDocuments.includes(item)) {
          $scope.selectedDocuments = $scope.selectedDocuments.concat(item);
        }
      };

      $scope.goToVerificaDocumenti = (item) => {
        store.set('fromState', $state.current.name);
        $state.go('home.verifica-documenti-caricati', ({classeDocumentale: item.Oggetto}));
      };

      let getClasseDocumentaleObjectByKey = (classeDocumentale) => {
        let classeDocumentaleObject;

        ng.forEach($scope.classeDocumentale, (value, key) => {
          if (value.key === classeDocumentale) {
            classeDocumentaleObject = value;
          }
        });

        return classeDocumentaleObject;
      };

      if ($scope.settings.filter.classeDocumentale !== '') {
        $scope.classeDocumentaleObject = getClasseDocumentaleObjectByKey($scope.settings.filter.classeDocumentale);
        $scope.settings.filter.pageNumber = 1;
        $scope.getItems();
      }

      $scope.previewModal = (item, type, size) => {
        let previewModalInstance = $uibModal.open({
          animation: true,
          component: 'previewModalComponent',
          controllerAs: 'vm',
          size: 'preview',
          resolve: {
            path: () => {
              return item.FilePath;
            },
            type: () => {
              return type;
            }
          }
        });
      };

      $scope.signAllFilesHavingStatusErroreFirma = () => {
        if (!$scope.user.useDigitalSign) {
          this.alertService.alert('warning', 'Si possono firmare tutti i documenti solamente se sono state configurate delle credenziali valide per la firma nella sezione <strong>Gestione Profilo</strong>.');
        } else {
          rabbitMQ.send('worker_digital_sign' + $rootScope.workerNameSuffix, JSON.stringify({user: $scope.user.accountData.email}));
          this.alertService.alert('info', 'Tutti i Documenti con stato <strong class="redlabel">Errore Firma</strong> verranno firmati usando le credenziali configurate e saranno preparati per la conservazione.');
        }

      };

      $scope.deleteSelectedItem = async () => {

        const conferma = $uibModal.open({
          animation: true,
          component: 'confermaEliminaDocConservazioneComponent',
          size: 'md',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            items: () => $scope.selectedItems
          }
        });

        if (await conferma.result) {
          ArchiSmallServices.deleteConservazioneDocument($scope.selectedDocuments.filter(item => ![2, 6, 9, 10].includes(item.Status)).map(item => item._id)).then((response: any) => {
            console.log(`successfully deleted ${response}`);
            $scope.selectedItem = {};
            $scope.selectedItems = [];
            $scope.selectedDocuments = [];
            $scope.getItems();
          }, (error) => {
            this.alertService.alert('error', error);
          });
        }
      };

      $scope.disableDelete = () => {
        return $scope.selectedDocuments ? $scope.selectedDocuments.every(item => [2, 6, 9, 10].includes(item.Status)) : true;
      };
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-consulta-documenti/conservazione-consulta-documenti.ts